<template>
  <div class="home">
    <Nav :list="list" @click="menuClick"></Nav>
    <router-view></router-view>
    <Dialog></Dialog>
    <Copy></Copy>
  </div>
</template>

<script>
import Nav from '../../components/nav'
import Copy from '../../components/copyright'
import Dialog from '../../components/model'
export default {
  name: "home",
  data() {
    return {
      list:[]
    }
  },
  components:{
    Nav,
    Copy,
    Dialog
  },
  methods:{
    menuClick (index, item, subMenu) {
      console.log('点击的索引是：' + index);
      console.table(item);
      console.table(subMenu);
    },
  }
}
</script>

<style scoped>

</style>